import { Box } from '@air/zephyr';

import { SectionData } from '~/lib/contentful/custom-types';
import { Container } from '~/old-marketing/components/Container';
import { Section } from '~/old-marketing/components/sections/Section';
import { SectionContent } from '~/old-marketing/components/sections/SectionContent';
import { SectionFieldTooltip } from '~/old-marketing/components/sections/SectionFieldTooltip';
import { SectionLabel } from '~/old-marketing/components/sections/SectionLabel';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';
import { worthlessStudiosTheme } from '~/old-marketing/components/sections/templates/worthless-studios/theme';
import { WorthlessStudiosFreeFilmsSectionTemplateAsset } from '~/old-marketing/components/sections/templates/WorthlessStudiosFreeFilmsSectionTemplate/WorthlessStudiosFreeFilmsSectionTemplateAsset';

const TEMPLATE_KEY = 'worthless-studios-free-films';

export type WorthlessStudiosFreeFilmsSectionTemplateProps = Pick<
  SectionData,
  'assets' | 'content' | 'id' | 'label' | 'title'
> & {
  isPreview?: boolean;
  isSubsection?: boolean;
};

export const WorthlessStudiosFreeFilmsSectionTemplate = ({
  assets,
  content,
  id,
  isPreview,
  isSubsection,
  label,
  title,
}: WorthlessStudiosFreeFilmsSectionTemplateProps) => {
  const asset = assets?.[0];

  return (
    <Section
      className={worthlessStudiosTheme}
      css={{
        backgroundColor: '$pigeon050',
        paddingTop: 208,
        paddingBottom: 64,

        '@laptop': {
          paddingTop: '11vw',
          paddingBottom: 56,
        },
      }}
      id={id}
      templateKey={TEMPLATE_KEY}
    >
      <Box
        tx={{
          position: 'absolute',
          top: 0,
          backgroundImage: 'linear-gradient(175deg, white 50%, #EFEFEF 50%)',
          width: '100%',
          height: '11vw',
        }}
      />
      <Container
        tx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: ['column', 'row'],
          justifyContent: 'space-between',
        }}
      >
        <Box
          tx={{ order: [2, 1], width: ['100%', '42%'], display: 'flex', justifyContent: 'flex-end', paddingRight: 24 }}
        >
          {asset && (
            <SectionFieldTooltip field="Asset (1)" isPreview={isPreview}>
              <WorthlessStudiosFreeFilmsSectionTemplateAsset {...asset} isPreview={isPreview} />
            </SectionFieldTooltip>
          )}
        </Box>

        <Box tx={{ order: [1, 2], width: ['100%', '58%'], maxWidth: 664, marginRight: 32, paddingLeft: 32 }}>
          {title && (
            <SectionTitle css={{ color: '$pigeon800' }} isSubsection={isSubsection} size="heading-48">
              {title}
            </SectionTitle>
          )}

          {label && (
            <SectionLabel css={{ color: '$pigeon800', letterSpacing: '-0.017em' }} size="ui-16">
              {label}
            </SectionLabel>
          )}

          {content && (
            <SectionContent
              content={content}
              css={{ marginTop: 32, color: '$pigeon800', letterSpacing: '-0.017em', lineHeight: '26px' }}
            />
          )}
        </Box>
      </Container>
    </Section>
  );
};

WorthlessStudiosFreeFilmsSectionTemplate.templateKey = TEMPLATE_KEY;
